module.exports = __webpack_public_path__ + "static/media/th-keypad-fake.dfcccee4.svg";